// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3ef5_","vLegacy":"SelectSecondary_vLegacy__PwfVr","error":"SelectSecondary_error__3TZR9","disabled":"SelectSecondary_disabled__1GG-D"};